import cn from 'classnames'
import Image from 'next/image'
import React from 'react'
import CatalogCategoriesSlider from '../catalog/CatalogCategoriesSlider'
import { useTranslation } from 'react-i18next'

interface IProps { }

export const featuresList = [
    {
        id: '1',
        title: '№1 в России',
        image_url: '/assets/img/b2b/today/frame-1.png',
        description: 'Крупнейший  производитель  премиксов в России и  один из крупнейших в  Европе'
    },
    {
        id: '2',
        title: '6 производств',
        image_url: '/assets/img/b2b/today/frame-2.png',
        description: '6 производственных  площадок, работающих  по международным  стандартам'
    },
    {
        id: '3',
        title: '32% российского рынка',
        image_url: '/assets/img/b2b/today/frame-3.png',
        description: '32% комбикормов в РФ производятся на основе премиксов Мегамикс'
    },
    {
        id: '4',
        title: '1% мирового рынка',
        image_url: '/assets/img/b2b/today/frame-4.png',
        description: '1% мирового рынка  кормов для  животных'
    },
    {
        id: '5',
        title: '1-й в мире сухой E 60%',
        image_url: '/assets/img/b2b/today/frame-5.png',
        description: 'Первый в мире  производитель сухого  кормового витамина Е  60%'
    },
    {
        id: '6',
        title: '3 лаборатории',
        image_url: '/assets/img/b2b/today/frame-6.png',
        description: '3 аккредитованные  научные лаборатории'
    },
    {
        id: '7',
        title: '7 офисов',
        image_url: '/assets/img/b2b/today/frame-7.png',
        description: '7 офисов в центральных  городах России'
    },
    {
        id: '8',
        title: 'GMP+',
        image_url: '/assets/img/b2b/today/frame-8.png',
        description: 'Первая в России  премиксная компания,  сертифицированная  по системе GMP+'
    }
]

interface ICardProps {
    item: any
    classItem?: string
}

export const B2BCard: React.FC<ICardProps> = ({ item, classItem }) => {
    return (
        <li className={cn(`categories-slider__card b2b__today-card`, classItem)}>
            <p className={`categories-slider__text`}>{item.title}</p>
            <Image
                quality={100}
                src={item.image_url}
                width={262}
                height={264}
                alt='feature-img'
                style={{
                    right: item.image_right,
                    bottom: item.image_bottom
                }}
            />
            {item.description && <p className='labs__features-hover-text'>{item.description}</p>}
        </li>
    )
}

export const B2BToday: React.FC<IProps> = () => {
    const {t} = useTranslation()

    const featuresListInner = [
        {
            id: '1',
            title: t("bestInRussia"),
            image_url: '/assets/img/b2b/today/frame-1.png',
            description: t("bestInRussiaAbout")
        },
        {
            id: '2',
            title: t("productionsCount"),
            image_url: '/assets/img/b2b/today/frame-2.png',
            description: t("productionsCountAbout")
        },
        {
            id: '3',
            title: t("percentInRussia"),
            image_url: '/assets/img/b2b/today/frame-3.png',
            description: t("percentInRussiaAbout")
        },
        {
            id: '4',
            title: t("percentGlobal"),
            image_url: '/assets/img/b2b/today/frame-4.png',
            description: t("percentGlobalAbout")
        },
        {
            id: '5',
            title: t("WorldsFirstVitE60"),
            image_url: '/assets/img/b2b/today/frame-5.png',
            description: t("WorldsFirstVitE60About")
        },
        {
            id: '6',
            title: t("LaboratoriesCount"),
            image_url: '/assets/img/b2b/today/frame-6.png',
            description: t("LaboratoriesCountAbout")
        },
        {
            id: '7',
            title: t("OfficesCount"),
            image_url: '/assets/img/b2b/today/frame-7.png',
            description: t("OfficesCountAbout")
        },
        {
            id: '8',
            title: t("gmpPlus"),
            image_url: '/assets/img/b2b/today/frame-8.png',
            description: t("gmpPlusAbout")
        }
    ]

    return (
        <div
            className='b2b__today'
            id='b2b-today'
        >
            <h2 className='main__section-title b2b__today-title'>{t("MegamixToday")}</h2>
            <div className='b2b__today-grid'>
                <ul
                    style={{ marginBottom: 120 }}
                    className='b2b__today-features'
                >
                    {featuresListInner.map(item => (
                        <B2BCard
                            key={item.id}
                            item={item}
                            classItem={'labs__features-card'}
                        />
                    ))}
                </ul>
            </div>
            <CatalogCategoriesSlider type='b2b' list={featuresListInner} />
        </div>
    )
}
